import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../models';

const initialState: User = {
  country: '',
  created: 0,
  dateFormat: '1',
  email: '',
  firstName: '',
  id: '',
  lastName: '',
  system: {},
  timeFormat: '1',
  language: '',
  uom: '0',
  roles: [],
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    initialize: (state, action: PayloadAction<Partial<User>>) => {
      const language = { language: state.language };

      return {
        ...initialState,
        ...language,
        ...action.payload,
      };
    },
    changeLanguage: (state, action: PayloadAction<string>) => {
      if (state.language !== action.payload) {
        state.language = action.payload;
      }
    },
    logout: (state) => {
      return {
        ...initialState,
        country: state.country,
        language: state.language,
      };
    },
  },
});

export const { initialize, changeLanguage, logout } = userSlice.actions;
export default userSlice.reducer;

// export const userReducer = (state = initialState, action: UserActions): UserState => {
//   switch (action.type) {
//     case INITIALIZE_USER:
//       return {
//         ...state,
//         ...action.user,
//       };

//     case LANGUAGE_CHANGE:
//       if (action.language === state.uiLanguage) {
//         return state;
//       }

//       return {
//         ...state,
//         uiLanguage: action.language,
//       };

//     case SET_PHONE_LANGUAGE:
//       return {
//         ...state,
//         phoneLanguage: action.language,
//       };

//     case LOGOUT:
//       return {
//         ...initialState,
//         country: state.country,
//         uiLanguage: state.uiLanguage,
//       };

//     default:
//       return state;
//   }
// };
